import React, { useState } from 'react';
import {
  NCZICompositionInfo,
  NCZIEntryInfo
} from '../../../../Interfaces/ncziTypes';
import { useEffectAsync } from '../../../../../../helpers';
import Loading from '../../../../../../Components/Loading';
import { useLazyNcziExtensionItemQuery } from '../../../../../../graphql/graphql';
import NZCIListItem from '../../../Base/NZCIListItem';
import { FormattedDateTime } from '../../../../../../Components/FormattedDate';

// @ts-ignore
import styles from './EHRCompositionInfo.module.scss';

interface Props {
  info: NCZICompositionInfo | NCZIEntryInfo | undefined;
}

const EHRCompositionInfo: React.FC<Props> = props => {
  const { info } = props;
  const [isReady, setIsReady] = useState<boolean>(false);
  const [infoUser, setInfoUser] = useState<string | null>(null);
  const [getExtensionItem] = useLazyNcziExtensionItemQuery();

  useEffectAsync(async () => {
    if (info?.user && info.user.scheme?.oid) {
      const { item: extensionItem } = await getExtensionItem({
        oid: info.user.scheme.oid,
        code: info.user.code
      }).unwrap();

      if (extensionItem) {
        setInfoUser(extensionItem.name || '');
      }
    }

    setIsReady(true);
  });

  if (!info) {
    return <></>;
  }

  if (!isReady) {
    return <Loading />;
  }

  return (
    <div className={styles.wrapper}>
      <NZCIListItem
        title='nczi.time'
        value={<FormattedDateTime datetime={info.time} />}
        extra={info.version}
      />
      {infoUser && <NZCIListItem title='nczi.author' value={infoUser} />}
    </div>
  );
};

export default EHRCompositionInfo;
